import { UserAuth } from '../../../src_server/entity/generated/UserAuth';


import { DaCourseOperatorDTO } from '../../../src_server/entity/dto/DaCourseOperatorDTO';


import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';


import { ClassBasicStrenghtLevel } from '../../../src_server/entity/generated/ClassBasicStrenghtLevel';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class DaTeacherService extends GeneratedBizBase{
  async getAllOperator(building_id: string): Promise<Response<UserAuth[]>> {
    return super.restCall<Response<UserAuth[]>>('get', '/v1/DaTeacherService/getAllOperator', arguments);
  }
  async getCourseOperator(cource_teacher_user_id: string): Promise<Response<DaCourseOperatorDTO[]>> {
    return super.restCall<Response<DaCourseOperatorDTO[]>>('get', '/v1/DaTeacherService/getCourseOperator', arguments);
  }
  async getTeachers(building_id: string): Promise<Response<TeacherInfoInputDTO[]>> {
    return super.restCall<Response<TeacherInfoInputDTO[]>>('get', '/v1/DaTeacherService/getTeachers', arguments);
  }
  async maintenanceUpdate(teacher_user_id: string,dto: TeacherInfoInputDTO): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/DaTeacherService/maintenanceUpdate', arguments);
  }
  async maintenanceAdd(info: TeacherInfoInputDTO,building_id: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/DaTeacherService/maintenanceAdd', arguments);
  }
  async getTeacher(teacher_user_id: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('get', '/v1/DaTeacherService/getTeacher', arguments);
  }
  async updateSelectedCourse(student_user_id: string,selectedTeachers: string[]): Promise<Response<string>> {
    return super.restCall<Response<string>>('post', '/v1/DaTeacherService/updateSelectedCourse', arguments);
  }
  async getCourses(teacher_user_id: string): Promise<Response<ClassBasicStrenghtLevel[]>> {
    return super.restCall<Response<ClassBasicStrenghtLevel[]>>('get', '/v1/DaTeacherService/getCourses', arguments);
  }
  async deleteInsertCourses(teacher_user_id: string,courses: ClassBasicStrenghtLevel[]): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DaTeacherService/deleteInsertCourses', arguments);
  }
  async copyTeachers(teacher_user_id: string): Promise<Response<TeacherInfoInputDTO>> {
    return super.restCall<Response<TeacherInfoInputDTO>>('post', '/v1/DaTeacherService/copyTeachers', arguments);
  }
}
